import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const FormWrapper = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
});

export default FormWrapper